import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";
import OrganizationTicketsReport from "../../../components/organization/reports/daily/OrganizationTickets";

const OrganizationTickets = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { reportRange, loading, tickets } = useSelector(
    (state) => state.defaultReducer
  );
  const reportTitle = `${reportIndex}. Organization Tickets`;
  console.log(reportTitle);
  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{reportTitle}</h1>
              <p>{getReportDescription(reportRange).Tickets}</p>

              <OrganizationTicketsReport reportIndex={reportIndex} />
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default OrganizationTickets;
